import { Loader } from "@googlemaps/js-api-loader";
import { MarkerClusterer, GridAlgorithm } from "@googlemaps/markerclusterer";

const loader = new Loader({
    apiKey: googleMapsApiKey,
    version: "3.59",
});

loader.load().then(async () => {
    const { InfoWindow } = await google.maps.importLibrary("maps");
    const { Geocoder } = await google.maps.importLibrary("geocoding");

    const mapWrapper = document.getElementById('shops-wrapper');
        if (mapWrapper) {
            window.storeLocator = {
                // -----------------------------------------------
                // Global variables, dataset and settings
                // -----------------------------------------------

                globals: {
                    development: 1,
                    form: 'form#store-locator-form',
                    results_list: '#locator-results-container .shop-items__inner',
                },
                // Map variables
                map: null,
                clusterer: null,
                markers: [],
                filteredType: [],
                geocoder: new Geocoder(),
                infoWindow: new InfoWindow(),
                defaultCenter: new google.maps.LatLng(52.0809819, 5.1060363),

                // Dataset
                dataset: typeof stores_dataset != "undefined" ? stores_dataset : [],

                // -----------------------------------------------
                // Intialization
                // -----------------------------------------------
                // App initializer
                init: function ($) {
                    // Initialize

                    // Disable console when development is disabled
                    if (!storeLocator.globals.development) {
                        // console.log('Store Locator :: development mode disabled');
                        storeLocator.helpers.disableConsole();
                    }

                    function setCity(lat, lng) {
                        let latlng = new google.maps.LatLng(lat, lng);
                        storeLocator.geocoder.geocode({ 'latLng': latlng }, function (results, status) {
                            let city = '';
                            if (status === google.maps.GeocoderStatus.OK) {
                                if (results[1]) {
                                    for (let i = 0; i < results[0].address_components.length; i++) {
                                        for (let b = 0; b < results[0].address_components[i].types.length; b++) {
                                            if (results[0].address_components[i].types[b] === "locality") {
                                                city += results[0].address_components[i].long_name;
                                            }
                                            if (results[0].address_components[i].types[b] === "country") {
                                                city += ', ' + results[0].address_components[i].long_name;
                                                break;
                                            }
                                        }
                                    }
                                }
                            }

                            if (city) {
                                jQuery('.locator-button').attr('data-location', city).addClass('enabled');
                            }
                        });
                    }

                    // This also requests the user to enable location sharing
                    if (document.body.classList.contains('page-template-page-dealers-new')) {
                        navigator.geolocation.getCurrentPosition(function (position) {
                            setCity(position.coords.latitude, position.coords.longitude);
                        });
                    }

                    // Run on load functions
                    storeLocator.general.onLoad();
                },

                // -----------------------------------------------
                // General functions
                // -----------------------------------------------
                general: {
                    // Perform on load statements and functions
                    onLoad: function () {
                        // Log function
                        // console.log('Store Locator :: general.onLoad() :: running');

                        // Initialize map
                        storeLocator.handlers.mapInit();

                        storeLocator.handlers.showAll();

                        // Attach listener to form submission
                        $(storeLocator.globals.form).on('submit', storeLocator.handlers.formSubmit);
                        $(storeLocator.globals.form).find('select').on('change', storeLocator.handlers.formSubmit);

                        // Check if we need to fake submit onload
                        if ($(storeLocator.globals.form).children('input.locator-query').val() !== '') {
                            $(storeLocator.globals.form).submit();
                        }

                        autocomplete(document.getElementById("locatorQuery"), storeLocator.markers);


                        // Filter markers
                        function filterMarkers(markerData) {
                            // Loop through marker data
                            for (let i = 0; i < markerData.length; i++) {
                                let storeType = markerData[i].store.store_type.toLowerCase();

                                if (!storeLocator.filteredType.includes(storeType)) {
                                    markerData[i].setVisible(false);
                                    markerData[i].setMap(null);
                                } else {
                                    markerData[i].setVisible(true);
                                    markerData[i].setMap(storeLocator.map);
                                }
                            }
                        }


                        $(document).on('click', '.c-legend__item', function () {
                            let markerData = storeLocator.markers;
                            let type = $(this).attr("data");

                            // If filteredtype array does not include store type, push store type into array
                            if (!storeLocator.filteredType.includes(type)) {
                                storeLocator.filteredType.push(type);
                            }

                            if ($(this).hasClass('checked')) {

                                // If item has checked class, remove this store type from the the array
                                storeLocator.filteredType.splice(storeLocator.filteredType.indexOf(type), 1);

                                // Check filteredtype array length
                                let filteredLength = storeLocator.filteredType.length;

                                // If filteredtype array length is equal to zero, push all store types into the array
                                if (filteredLength === 0) {
                                    storeLocator.filteredType.push('studio', 'store', 'point');
                                }

                                filterMarkers(markerData);
                                $(this).removeClass('checked');
                            } else {

                                // Check filteredtype array length
                                let filteredLength = storeLocator.filteredType.length;

                                // Check if filteredtype array length is 3 and if siblings do not have the checked class
                                if (filteredLength === 3 && !($(this).siblings().hasClass('checked'))) {

                                    // Empty the array
                                    storeLocator.filteredType.length = 0;

                                    // Push the store type to the array
                                    storeLocator.filteredType.push(type);
                                }

                                $(this).addClass('checked');
                                filterMarkers(markerData);
                            }
                        });
                    }
                },

                // -----------------------------------------------
                // Event handlers
                // -----------------------------------------------
                handlers: {
                    // Map initialization
                    mapInit: function () {
                        // Log function
                        // console.log('Store Locator :: handler.mapInit() :: running');

                        // Define options
                        let mapOptions = {
                            center: storeLocator.defaultCenter,
                            zoom: 7,
                            scrollwheel: false,
                            disableDefaultUI: true,
                            zoomControl: true,
                            zoomControlOptions: {
                                position: google.maps.ControlPosition.RIGHT_BOTTOM
                            },
                            styles: [
                                {
                                    "featureType": "all",
                                    "elementType": "geometry",
                                    "stylers": [
                                        {
                                            "color": "#202c3e"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "all",
                                    "elementType": "labels.text.fill",
                                    "stylers": [
                                        {
                                            "gamma": 0.01
                                        },
                                        {
                                            "lightness": 20
                                        },
                                        {
                                            "weight": "1.39"
                                        },
                                        {
                                            "color": "#ffffff"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "all",
                                    "elementType": "labels.text.stroke",
                                    "stylers": [
                                        {
                                            "weight": "0.96"
                                        },
                                        {
                                            "saturation": "9"
                                        },
                                        {
                                            "visibility": "on"
                                        },
                                        {
                                            "color": "#000000"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "all",
                                    "elementType": "labels.icon",
                                    "stylers": [
                                        {
                                            "visibility": "off"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "landscape",
                                    "elementType": "geometry",
                                    "stylers": [
                                        {
                                            "lightness": 30
                                        },
                                        {
                                            "saturation": "9"
                                        },
                                        {
                                            "color": "#29446b"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "poi",
                                    "elementType": "geometry",
                                    "stylers": [
                                        {
                                            "saturation": 20
                                        }
                                    ]
                                },
                                {
                                    "featureType": "poi.park",
                                    "elementType": "geometry",
                                    "stylers": [
                                        {
                                            "lightness": 20
                                        },
                                        {
                                            "saturation": -20
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road",
                                    "elementType": "geometry",
                                    "stylers": [
                                        {
                                            "lightness": 10
                                        },
                                        {
                                            "saturation": -30
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road",
                                    "elementType": "geometry.fill",
                                    "stylers": [
                                        {
                                            "color": "#193a55"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "road",
                                    "elementType": "geometry.stroke",
                                    "stylers": [
                                        {
                                            "saturation": 25
                                        },
                                        {
                                            "lightness": 25
                                        },
                                        {
                                            "weight": "0.01"
                                        }
                                    ]
                                },
                                {
                                    "featureType": "water",
                                    "elementType": "all",
                                    "stylers": [
                                        {
                                            "lightness": -20
                                        }
                                    ]
                                },
                                {
                                    "featureType": "poi.park",
                                    "stylers": [
                                        { "visibility": "off" }
                                    ]
                                },
                                {}
                            ],
                        };

                        // Create map and store in variable
                        storeLocator.map = new google.maps.Map(document.getElementById("stores-map"), mapOptions);

                        // Parse markers on map
                        for (let item in storeLocator.dataset) {
                            if (storeLocator.dataset.hasOwnProperty(item)) {
                                storeLocator.handlers.createMapMarker(storeLocator.dataset[item]);
                            }
                        }

                        // Cluster markers
                        storeLocator.helpers.clusterMarkers();

                        // Less stressful for mobiles
                        if (!storeLocator.helpers.checkMobile()) {
                            // Add listener for viewport change
                            google.maps.event.addListener(storeLocator.map, 'idle', storeLocator.handlers.listVisibleStores);
                            google.maps.event.addListener(storeLocator.map, 'idle', storeLocator.handlers.listVisibleStoresStoreName);

                            // Re-align center on window resize
                            window.addEventListener("resize", function () {
                                let center = storeLocator.map.getCenter();
                                google.maps.event.trigger(storeLocator.map, "resize");
                                storeLocator.map.panTo(center);
                            })
                        }
                    },

                    // Create marker
                    createMapMarker: function (store) {
                        const {
                            store_type: storeType,
                            original: storeOriginal,
                            title: storeTitle,
                            address: storeAddress,
                            zip_city: storeZipCity,
                            logo: storeLogo,
                            afspraak_url: storeAfspraakUrl,
                            permalink: storePermalink,
                            showButton: storeShowButton,
                            appointment_disabled: storeAppointmentDisabled,
                        } = store



                        // Create store type file name
                        let store_type_file_name = storeType.replace(/ /g, '-').toLowerCase();

                        // Create marker icon
                        let marker_icon = {
                            url: store_marker_path + store_type_file_name + '.svg',
                            scaledSize: new google.maps.Size(50, 50),
                        };


                        // Create a custom HTML element for the marker content
                        let markerContent = document.createElement('div');
                        markerContent.className = 'custom-marker';
                        markerContent.innerHTML = `<img src="${marker_icon.url}" style="width: 50px; height: 50px;">`;

                        let shop_type_label = store.store_type.toLowerCase();

                        // Forge marker tooltip html
                        let original = storeOriginal === "Ja" ? '<span class="shop-type-original">Original</span>' : '';
                        let logoElement = storeLogo != null ? '<img class="shop-image" src="' + storeLogo + '" />' : '';

                        let html = '<div class="marker-tooltip"> \
                                    <div class="content"> \
                                        <span id="shop-type" class="shop-type ' + shop_type_label + '">' + (shop_type_label === 'studio' ? 'Studio' : storeType.replace('Pullman ', '')) + '</span> \
                                        ' + original + ' \
                                        ' + logoElement + ' \
                                        <h2>' + storeTitle + '</h2> \
                                        <ul> \
                                             ' + (store.calculatedDistance ? '<li class="store-distance">' + (Math.round(store.calculatedDistance * 10) / 10) + ' km</li>' : '') + ' \
                                            <li>' + storeAddress + '</li> \
                                            <li>' + storeZipCity + '</li> \
                                        </ul> \
                                    ';

                        html = html + '</div>';

                        if (storeAfspraakUrl || (storePermalink && storeShowButton !== false && store.store_type !== 'Point')) {
                            html = html + '<div class="buttons">';

                            if (storePermalink && storeShowButton !== false && store.store_type !== 'Point') {
                                html = html + '<a class="button button--ghost" href="' + storePermalink + '" onclick="dataLayer.push({\'event\':\'winkelbekijken\', \'winkelkeuze\':\'' + storeTitle + '\'});">Bekijk winkel</a>';
                            }

                            if (storeAfspraakUrl && storeAppointmentDisabled !== true) {
                                html = html + '<a class="button" href="' + storeAfspraakUrl + '" onclick="dataLayer.push({\'event\':\'afspraakmaken\', \'winkelkeuze\':\'' + storeTitle + '\'});">Plan uw bezoek</a>';
                            }
                            html = html + '</div>';
                        }

                        html = html + '</div>';

                        // Create marker
                        let zIndexStore = 1;

                        if (storeType === '01 Store') {
                            zIndexStore = 10;
                        }

                        let marker = new google.maps.Marker({
                            map: storeLocator.map,
                            position: new google.maps.LatLng(store.coordinates.lat, store.coordinates.lng),
                            icon: marker_icon ? marker_icon : null, // null = default icon,
                            zIndex: zIndexStore
                        });

                        // Alter marker to contain original store data
                        marker.store = store;

                        // Create clickhandler for marker
                        google.maps.event.addListener(marker, 'click', function () {
                            // Calculate distance when marker is clicked
                            let mapCenter = {
                                lat: storeLocator.map.getCenter().lat(),
                                lng: storeLocator.map.getCenter().lng()
                            };

                            store.calculatedDistance = storeLocator.helpers.getDistanceByLotLang(
                                store.coordinates.lat,
                                store.coordinates.lng,
                                mapCenter.lat,
                                mapCenter.lng
                            );

                            // Regenerate HTML with the calculated distance
                            let updatedHtml = '<div class="marker-tooltip"> \
                                <div class="content"> \
                                    <span id="shop-type" class="shop-type ' + shop_type_label + '">' + (shop_type_label === 'studio' ? 'Studio' : storeType.replace('Pullman ', '')) + '</span> \
                                    ' + original + ' \
                                    ' + logoElement + ' \
                                    <h2>' + storeTitle + '</h2> \
                                    <ul> \
                                            ' + (store.calculatedDistance ? '<li class="store-distance">' + (Math.round(store.calculatedDistance * 10) / 10) + ' km</li>' : '') + ' \
                                        <li>' + storeAddress + '</li> \
                                        <li>' + storeZipCity + '</li> \
                                    </ul> \
                                </div>';

                            if (storeAfspraakUrl || (storePermalink && storeShowButton !== false && store.store_type !== 'Point')) {
                                updatedHtml += '<div class="buttons">';
                                if (storePermalink && storeShowButton !== false && store.store_type !== 'Point') {
                                    updatedHtml += '<a class="button button--ghost" href="' + storePermalink + '" onclick="dataLayer.push({\'event\':\'winkelbekijken\', \'winkelkeuze\':\'' + storeTitle + '\'});">Bekijk winkel</a>';
                                }
                                if (storeAfspraakUrl && storeAppointmentDisabled !== true) {
                                    updatedHtml += '<a class="button" href="' + storeAfspraakUrl + '" onclick="dataLayer.push({\'event\':\'afspraakmaken\', \'winkelkeuze\':\'' + storeTitle + '\'});">Plan uw bezoek</a>';
                                }
                                updatedHtml += '</div>';
                            }

                            updatedHtml += '</div>';

                            storeLocator.infoWindow.setContent(updatedHtml);
                            storeLocator.infoWindow.open(storeLocator.map, marker);

                            // Add class to hide legend
                            document.querySelector('.c-legend').classList.add('hidden');
                        });

                        marker.infoWindow = storeLocator.infoWindow;

                        // Show tooltip
                        google.maps.event.addListener(storeLocator.infoWindow, 'domready', function () {
                            document.getElementById('shop-type').onclick = function () {
                                let dealersMap = document.getElementsByClassName("dealers-map");
                                dealersMap[0].classList.add('show-tooltips');
                            }
                        });

                        // Add listener to close info window
                        google.maps.event.addListener(storeLocator.infoWindow, 'closeclick', function () {
                            // Remove class to show legend
                            document.querySelector('.c-legend').classList.remove('hidden');
                        });

                        // Store marker into array for later use
                        storeLocator.markers.push(marker);
                    },

                    // Put the center of the map on the given query
                    focusMapOnQuery: function (query) {
                        $(storeLocator.globals.results_list).empty();
                        let self = this;
                        let queryLower = query.toLowerCase();

                        // First try exact city/postal matches
                        let cityMatches = storeLocator.dataset.filter(function (store) {
                            let cityParts = store.zip_city.toLowerCase().split(' ');
                            return cityParts.some(part => part === queryLower);
                        });

                        if (cityMatches.length > 0) {
                            // Handle city matches like before
                            let lowestLat, highestLat, lowestLong, highestLong;

                            for (let i = 0; i < cityMatches.length; i++) {
                                let store = cityMatches[i];

                                if (!lowestLat || store.coordinates.lat < lowestLat) {
                                    lowestLat = store.coordinates.lat;
                                }
                                if (!highestLat || store.coordinates.lat > highestLat) {
                                    highestLat = store.coordinates.lat;
                                }
                                if (!lowestLong || store.coordinates.lng < lowestLong) {
                                    lowestLong = store.coordinates.lng;
                                }
                                if (!highestLong || store.coordinates.lng > highestLong) {
                                    highestLong = store.coordinates.lng;
                                }

                                $(storeLocator.globals.results_list).append(storeLocator.helpers.generateTemplate(store));
                            }

                            let bounds = new google.maps.LatLngBounds(
                                new google.maps.LatLng(lowestLat, lowestLong),
                                new google.maps.LatLng(highestLat, highestLong)
                            );

                            storeLocator.map.fitBounds(bounds);
                            storeLocator.map.setZoom(11);
                            storeLocator.helpers.setShopResultsVisible(true);
                            $('.dealers-map').removeClass('no-postal');
                            $('.dealers-map__list').find('.title').html('Winkels in uw regio');
                            return;
                        }

                        // If no city matches, try geocoding
                        storeLocator.geocoder.geocode({
                            'address': query,
                            'region': 'NL' // Restrict to Netherlands
                        }, function (results, status) {
                            if (status === google.maps.GeocoderStatus.OK) {
                                let latlng = results[0].geometry.location;
                                let bounds = results[0].geometry.bounds;

                                // Check if result is actually a city
                                let isCity = results[0].types.includes('locality') ||
                                            results[0].types.includes('postal_code');

                                if (isCity) {
                                    storeLocator.map.panTo(latlng);
                                    storeLocator.map.fitBounds(bounds || new google.maps.LatLngBounds(
                                        new google.maps.LatLng(latlng.lat() - 0.1, latlng.lng() - 0.1),
                                        new google.maps.LatLng(latlng.lat() + 0.1, latlng.lng() + 0.1)
                                    ));
                                    storeLocator.map.setZoom(11);
                                    storeLocator.handlers.listVisibleStores();
                                    return;
                                }
                            }

                            // Fall back to address search only if nothing else worked
                            let addressMatches = storeLocator.dataset.filter(function (store) {
                                return store.address.toLowerCase().includes(queryLower);
                            });

                            if (addressMatches.length > 0) {
                                // Handle address matches similar to city matches...
                                // ...existing address matching code...
                            } else {
                                console.error('No results found for: ' + query);
                                let emptyHtml = '\
                                <li class="list__item"> \
                                    Er zijn geen resultaten op basis van de ingevulde postcode / stad. \
                                </li>';
                                $(storeLocator.globals.results_list).append(emptyHtml);
                            }
                        });
                    },

                    // Get all stores and and present them in html list
                    listAllStores: function () {
                        // Log function

                        // Empty result list
                        $(storeLocator.globals.results_list).empty();

                        // Grab map bounds
                        let mapBounds = storeLocator.map.getBounds();

                        let mapCenter = {
                            lat: storeLocator.map.getCenter().lat(),
                            lng: storeLocator.map.getCenter().lng(),
                        };

                        let storesInBounds = [];

                        // Loop through markers
                        let totalInBounds = 0;
                        for (let i = 0; i < storeLocator.markers.length; i++) {
                            // Check if marker is within view
                            if (storeLocator.markers[i].visible) {
                                // Add one to total in bounds
                                totalInBounds++;
                                if (totalInBounds >= 50 && storeLocator.map.getZoom() <= 11) {
                                    continue;
                                }

                                // Grab store data and disable buttons
                                let store = storeLocator.markers[i].store;
                                store.showButton = false;
                                store.appointment_disabled = true;

                                // Lets calculate the distance here already, so we don't have to do this in the compare function multiple times.
                                store.calculatedDistance = storeLocator.helpers.getDistanceByLotLang(
                                        store.coordinates.lat,
                                        store.coordinates.lng,
                                        mapCenter.lat,
                                        mapCenter.lng
                                );

                                storesInBounds.push(store);
                            }
                        }

                // Find the closest store first, then sort the rest by distance only
                let closestStore = null;
                let otherLocations = [];
                let closestDistance = Infinity;

                // First pass: find the closest store
                storesInBounds.forEach(store => {
                    if (store.store_type.toLowerCase().includes('store')) {
                        if (store.calculatedDistance < closestDistance) {
                            if (closestStore) {
                                otherLocations.push(closestStore);
                            }
                            closestStore = store;
                            closestDistance = store.calculatedDistance;
                        } else {
                            otherLocations.push(store);
                        }
                    } else {
                        otherLocations.push(store);
                    }
                });

                // Sort all other locations by distance only - no type consideration
                otherLocations.sort((a, b) => {
                    if (a.calculatedDistance < b.calculatedDistance) return -1;
                    if (a.calculatedDistance > b.calculatedDistance) return 1;
                    return 0;
                });

                // Combine results: closest store first, then all others sorted by distance
                storesInBounds = closestStore ? [closestStore, ...otherLocations] : otherLocations;                        storeLocator.helpers.setShopResultsVisible(storesInBounds.length <= 16);

                        storesInBounds.forEach((st) => {
                            $(storeLocator.globals.results_list).append(storeLocator.helpers.generateTemplate(st));
                        });

                        if (!storesInBounds.length) {
                            let emptyHtml = '\
                        <li class="list__item"> \
                        Er zijn geen resultaten op basis van de ingevulde postcode / stad. \
                            </li> \
                            ';

                            $(storeLocator.globals.results_list).append(emptyHtml);
                        }
                    },

                    // Check for stores in map-view and present them in html list
                    listVisibleStores: function () {

                    // Empty result list
                    $(storeLocator.globals.results_list).empty();

                    // Grab map bounds
                    let mapBounds = storeLocator.map.getBounds();

                    let mapCenter = {
                        lat: storeLocator.map.getCenter().lat(),
                        lng: storeLocator.map.getCenter().lng(),
                    };

                    let storesInBounds = [];

                    // Loop through markers
                    let totalInBounds = 0;
                    for (let i = 0; i < storeLocator.markers.length; i++) {
                        // Check if marker is within view

                        // !!!!!!!! VISIBLE doesnt exist on ADVANCED MARKERS - reverted back to old markers for now
                        if (storeLocator.markers[i].visible && mapBounds && mapBounds.contains(storeLocator.markers[i].getPosition())) {

                            // Add one to total in bounds
                            totalInBounds++;
                            if (totalInBounds >= 50 && storeLocator.map.getZoom() <= 11) {
                                continue;
                            }

                            // Grab store data and enable buttons
                            let store = storeLocator.markers[i].store;
                            store.showButton = true;
                            store.appointment_disabled = false;

                            // Lets calculate the distance here already, so we don't have to do this in the compare function multiple times.
                            store.calculatedDistance = storeLocator.helpers.getDistanceByLotLang(
                                store.coordinates.lat,
                                store.coordinates.lng,
                                mapCenter.lat,
                                mapCenter.lng
                            );

                            // Log findings

                            storesInBounds.push(store);
                        }
                    }

                    // Find the closest Pullman store and put it first, then sort the rest by distance only
                    let closestPullmanStore = null;
                    let otherStores = [];
                    let closestPullmanDistance = Infinity;

                    // First pass: find the closest Pullman store
                    storesInBounds.forEach(store => {
                        if (store.store_type.toLowerCase().includes('store')) {
                            if (store.calculatedDistance < closestPullmanDistance) {
                                if (closestPullmanStore) {
                                    otherStores.push(closestPullmanStore);
                                }
                                closestPullmanStore = store;
                                closestPullmanDistance = store.calculatedDistance;
                            } else {
                                otherStores.push(store);
                            }
                        } else {
                            otherStores.push(store);
                        }
                    });

                    // Sort other stores by distance only
                    otherStores.sort((a, b) => {
                        if (a.calculatedDistance < b.calculatedDistance) return -1;
                        if (a.calculatedDistance > b.calculatedDistance) return 1;
                        return 0;
                    });

                     // Mark the closest store and combine results
                    if (closestPullmanStore) {
                        closestPullmanStore.isClosestStore = true;
                        storesInBounds = [closestPullmanStore, ...otherStores];
                    } else {
                        storesInBounds = otherStores;
                    }

                    storeLocator.helpers.setShopResultsVisible(storesInBounds.length <= 16);

                    storesInBounds.forEach((st) => {
                        $(storeLocator.globals.results_list).append(storeLocator.helpers.generateTemplate(st));
                    });

                    if (!storesInBounds.length) {
                        let emptyHtml = '\
                    <li class="list__item"> \
                    Er zijn geen resultaten op basis van de ingevulde postcode / stad. \
                        </div> \
                        ';

                        $(storeLocator.globals.results_list).append(emptyHtml);
                    }
                    // Check for listed children
                    if ($(storeLocator.globals.results_list).children('div.shop-item').length > 0) {
                        // Add total count
                        // $(storeLocator.globals.results_list).prepend('<div class="result-count">'+totalInBounds+' punten op de kaart</div>');
                        // Match all new list items' height
                        // 				$(storeLocator.globals.results_list).children('div.shop-item').matchHeight();
                        // 				$(storeLocator.globals.results_list).childrenti'div.shop-item').matchHeight();
                    }
                },


                    // Check for stores in map-view and present them in html list
                    listVisibleStoresStoreName: function () {
                        if (!self.storeName) return;

                // Empty result list
                $(storeLocator.globals.results_list).empty();

                // Grab map bounds
                let mapBounds = storeLocator.map.getBounds();

                let mapCenter = {
                    lat: storeLocator.map.getCenter().lat(),
                    lng: storeLocator.map.getCenter().lng(),
                };

                let showStores = [];

                // Loop through markers
                let totalInBounds = 0;
                for (let i = 0; i < storeLocator.markers.length; i++) {
                    // Check if marker is within view
                    if (storeLocator.markers[i].visible && mapBounds && mapBounds.contains(storeLocator.markers[i].getPosition())) {
                        // Add one to total in bounds
                        totalInBounds++;
                        if (totalInBounds >= 50 && storeLocator.map.getZoom() <= 11) {
                            continue;
                        }

                        // Grab store data
                        let store = storeLocator.markers[i].store;

                        // Lets calculate the distance here already, so we don't have to do this in the compare function multiple times.
                        store.calculatedDistance = storeLocator.helpers.getDistanceByLotLang(
                            store.coordinates.lat,
                            store.coordinates.lng,
                            mapCenter.lat,
                            mapCenter.lng
                        );

                        // Log findings
                        // console.log('Store Locator :: handlers.listVisibleStores() :: store within bounds: ', store);

                        showStores.push(store);
                    }
                }

                // Find the closest store first, then sort the rest by distance only
                let closestStore = null;
                let otherLocations = [];
                let closestDistance = Infinity;

                // First pass: find the closest store
                showStores.forEach(store => {
                    if (store.store_type.toLowerCase().includes('store')) {
                        if (store.calculatedDistance < closestDistance) {
                            if (closestStore) {
                                otherLocations.push(closestStore);
                            }
                            closestStore = store;
                            closestDistance = store.calculatedDistance;
                        } else {
                            otherLocations.push(store);
                        }
                    } else {
                        otherLocations.push(store);
                    }
                });

                // Sort all other locations by distance only - no type consideration
                otherLocations.sort((a, b) => {
                    if (a.calculatedDistance < b.calculatedDistance) return -1;
                    if (a.calculatedDistance > b.calculatedDistance) return 1;
                    return 0;
                });

                // Mark the closest store and combine results
                if (closestStore) {
                    closestStore.isClosestStore = true;
                    showStores = [closestStore, ...otherLocations];
                } else {
                    showStores = otherLocations;
                }

                storeLocator.helpers.setShopResultsVisible(showStores.length <= 16);

                showStores.forEach((st) => {
                    $(storeLocator.globals.results_list).append(storeLocator.helpers.generateTemplate(st));
                });

                if (!showStores.length) {
                    let emptyHtml = '\
                <li class="list__item"> \
                Er zijn geen resultaten op basis van de ingevulde naam. \
            		</li> \
					';

                    $(storeLocator.globals.results_list).append(emptyHtml);
                }
                // Check for listed children
                if ($(storeLocator.globals.results_list).children('div.shop-item').length > 0) {
                    // Add total count
                    // $(storeLocator.globals.results_list).prepend('<div class="result-count">'+totalInBounds+' punten op de kaart</div>');
                    // Match all new list items' height
                    // 				$(storeLocator.globals.results_list).children('div.shop-item').matchHeight();
                    // 				$(storeLocator.globals.results_list).childrenti'div.shop-item').matchHeight();
                }
                // If none are listed, provide feedback
                /*			else {
                                $(storeLocator.globals.results_list).append('<div class="no-results">'+no_points_on_map_str+'</div>'); // no_points_on_map is defined in the wordpress-template
                            }*/
                },

                    showAll: function () {
                        // Log function and prevent default behaviour
                        // console.log('Store Locator :: handlers.formSubmit() :: fired');
                        storeLocator.helpers.preventDefault(event);

                        // Adjust map
                        storeLocator.helpers.setShopResultsVisible(true);
                        storeLocator.handlers.listAllStores();
                        $('.dealers-map').removeClass('no-postal');
                        $('.dealers-map__list').find('.title').html('Winkels in uw regio');
                    },

                    // Formsubmission handler
                    formSubmit: function (event) {
                        // Log function and prevent default behaviour
                        // console.log('Store Locator :: handlers.formSubmit() :: fired');
                        storeLocator.helpers.preventDefault(event);

                        $(storeLocator.globals.form).find('input, select').blur();

                        storeLocator.helpers.clusterMarkers();

                        // Grab query
                        let query = '';

                        // set default center
                        storeLocator.map.setCenter(storeLocator.defaultCenter);
                        storeLocator.map.setZoom(7);

                        $(storeLocator.globals.form).find('input.locator-query').each(function () {
                            if ($(this).is(':visible')) {
                                query += $(this).val();
                            } else {
                                $(this).val('');
                            }
                        });

                        let storeName = '';
                        $(storeLocator.globals.form).find('input.locator-companyquery').each(function () {
                            if ($(this).is(':visible')) {

                                storeName += $(this).val();

                                // Replaces special characters so the titles are equal to the title in de dataset
                                storeName = storeName.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
                                    return '&#' + i.charCodeAt(0) + ';';
                                });
                            } else {
                                $(this).val('');
                            }
                        });

                        storeLocator.query = query;

                        if (dataLayer) {
                            dataLayer.push({ 'event': 'winkelzoeken', 'zoekopdracht': query });
                            //console.log('Store Locator :: DataLayer "winkelzoeken" event :: Zoekopdracht: "'+query+'"');
                        }

                        // Adjust map
                        // This function will later list items if needed
                        if (query && !storeName) {
                            // console.log(query);
                            if (!storeLocator.markers.length) {
                                // Parse markers on map
                                for (let item in storeLocator.dataset) {
                                    if (storeLocator.dataset.hasOwnProperty(item)) {
                                        storeLocator.handlers.createMapMarker(storeLocator.dataset[item]);
                                    }
                                }

                                // Cluster markers
                                storeLocator.helpers.clusterMarkers();
                            }

                            storeLocator.helpers.setShopResultsVisible(true);
                            storeLocator.handlers.listVisibleStores();
                            storeLocator.handlers.focusMapOnQuery(query);
                            self.query = query;
                            $('.dealers-map').removeClass('no-postal');
                            $('.dealers-map__list').find('.title').html('Winkels in uw regio');
                        } else {
                            storeLocator.helpers.setShopResultsVisible(false);
                            storeLocator.handlers.listVisibleStores();
                        }
                    },
                },

                // -----------------------------------------------
                // Helpers
                // -----------------------------------------------
                helpers: {
                    createTooltipHtmlOnly: function (store) {

                        let shop_type_label = store.store_type.toLowerCase();

                        let html = '<div class="marker-tooltip"> \
                                    <div class="content"> \
                                        <span id="shop-type" class="shop-type ' + shop_type_label + '">' + store.store_type.replace('Pullman ', '').replace('02 ').replace('04 ') + '</span> \
                                        <h2>' + store.title + '</h2> \
                                        <ul> \
                                            <li>' + store.address + '</li> \
                                            <li>' + store.zip_city + '</li> \
                                        </ul> \
                                        ';

                        html = html + '</div>';

                        if (store.afspraak_url || (store.permalink && store.showButton !== false && store.store_type !== 'Point')) {
                            html = html + '<div class="buttons">';

                            if (store.permalink && store.showButton !== false && store.store_type !== 'Point') {
                                html = html + '<a class="button button--ghost" href="' + store.permalink + '" onclick="dataLayer.push({\'event\':\'winkelbekijken\', \'winkelkeuze\':\'' + store.title + '\'});">Bekijk winkel</a>';
                            }

                            if (store.afspraak_url && store.appointment_disabled !== true) {
                                html = html + '<a class="button" href="' + store.afspraak_url + '" onclick="dataLayer.push({\'event\':\'afspraakmaken\', \'winkelkeuze\':\'' + store.title + '\'});">Plan uw bezoek</a>';
                            }
                            html = html + '</div>';
                        }

                        html = html + '</div>';

                        return html;
                    },

                    clusterMarkers: function () {
                            let renderer = {
                                render(cluster, stats, map) {
                                    const count = cluster.count;
                                    const position = cluster.position;

                                    return new google.maps.Marker({
                                        position,
                                        icon: {
                                            url: "https://www.pullman.nl/wp-content/themes/pullman/assets/images/m1.png",
                                            scaledSize: new google.maps.Size(55, 55),
                                        },
                                        label: {
                                            text: String(count),
                                            color: "white",
                                            fontSize: "9px",
                                            fontFamily: "Arial",
                                        },
                                        title: `Cluster of ${count} markers`,
                                        zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                                    });
                                }
                            };

                            let algorithm = new GridAlgorithm({
                                gridSize: 60,
                                maxZoom: 10,
                            });

                            // Instantiate MarkerClusterer
                            storeLocator.clusterer = new MarkerClusterer({
                                map: storeLocator.map,
                                markers: storeLocator.markers,
                                renderer,
                                algorithm
                            });
                    },

                    generateTemplate: function (store) {
                        let shop_type_label = store.store_type.toLowerCase(); // Define shop_type_label here

                        let shop_bullet_points = '<li>Pullman matrassenassortiment</li><li>Pullman boxspringassortiment</li>';

                        if (store.store_type === 'Point') {
                            shop_bullet_points = '<li>Pullman matrassenassortiment</li>';
                        }

                        let original = store.original === "Ja" ? '<span class="shop-type-original"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">\n' +
                            '<path d="M3.33333 10.6666L2 3.33329L5.66667 6.66663L8 2.66663L10.3333 6.66663L14 3.33329L12.6667 10.6666H3.33333ZM12.6667 12.6666C12.6667 13.0666 12.4 13.3333 12 13.3333H4C3.6 13.3333 3.33333 13.0666 3.33333 12.6666V12H12.6667V12.6666Z" fill="#C99F35"/>\n' +
                            '</svg>\n Pullman Original assortiment</span>' : '';
                        let storeHtml = '\
                        <li class="list__item type-' + store.store_type + (store.isClosestStore ? ' list__item--closest-store' : '') + '" ' + store.datatags + '> \
                            ' + (store.isClosestStore ? '<span class="closest-store-block-heading">Dichtstbijzijnde Pullman Store bij u in de buurt</span>' : '') + ' \
                            <div class="right-content">\
                                <div class="list__header">\
                                    <a href="' + (store.store_type === 'Point' ? store.afspraak_url : store.permalink) + '">\
                                        ' + (!store.isClosestStore ? '<span class="shop-type ' + shop_type_label.toLowerCase() + '">Pullman ' + (shop_type_label === 'studio' ? 'Studio' : store.store_type) + '</span>' : '') + '\
                                        <div class="list__header-inner">\
                                        <h4>' + store.title + '</h4>\
                                        ' + (store.calculatedDistance ? '<span class="store-distance">' + (Math.round(store.calculatedDistance * 10) / 10) + ' km</span>' : '') + '\
                                        </div>\
                                    </a> \
                                </div>\
                                <ul class="shop_assortiment">' + shop_bullet_points + '</ul> \
                                ' + original + ' \
                                <ul class="contact-info"> \
                                    <li>' + store.address + '</li> \
                                    <li>' + store.zip_city + '</li> \
                                    <li><a href="tel:' + store.phone + '">' + store.phone + '</a></li> \
                                </ul> \
                                <div class="buttons"> \
                                ';

                        if (store.permalink && store.showButton !== false && store.store_type !== 'Point') {
                            storeHtml = storeHtml + '\
                                            <a class="button button--' + (store.isClosestStore ? 'outline' : 'ghost') + '" href="' + store.permalink + '" onclick="dataLayer.push({\'event\':\'winkelbekijken\', \'winkelkeuze\':\'' + store.title + '\'});">Bekijk winkel</a> \
                                            ';
                        }
                        if (store.afspraak_url && store.appointment_disabled !== true) {
                            storeHtml = storeHtml + '\
                                            <a class="button" href="' + store.afspraak_url + '" onclick="dataLayer.push({\'event\':\'afspraakmaken\', \'winkelkeuze\':\'' + store.title + '\'});">Plan uw bezoek</a> \
                                            ';
                        }

                        storeHtml = storeHtml + '\
                                    </div> \
                                \
                                </div>\
                            <hr></li>\
                            ';

                        storeHtml = storeHtml + '\
                                    </div> \
                                \
                                </div>\
                            </div>\
                            ';

                        storeHtml = storeHtml + '\
                                    </div> \
                                \
                                </div>\
                            </div>\
                            ';

                        return storeHtml;
                    },

                    // Disable manual console logging, error reporting, warnings, and so forth.
                    disableConsole: function () {
                        // Log function
                        //console.log('Store Locator :: helpers.disableConsole() :: running');

                        // Disable console (and thus any further logging/reporting)
                        console = {
                            log: function () {
                            },
                            info: function () {
                            },
                            warn: function () {
                            },
                            error: function () {
                            },
                        }
                    },

                    // Prevent default browser behaviour
                    preventDefault: function (event) {
                        // Log function
                        //console.log('Store Locator :: helpers.preventDefault() :: fired :: ', event);

                        // Prevent default, stop propagation, stop immediate propagation and return false
                        event.preventDefault();
                        event.stopPropagation();
                        event.stopImmediatePropagation();
                        return false;
                    },

                    setShopResultsVisible: function (shown) {
                        if (shown) {
                            $("#locator-results-container").show();
                        } else {
                            $("#locator-results-container").show();
                        }
                    },

                    // Mobile detection
                    checkMobile: function () {
                        let check = false;
                        (function (a) {
                            if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true
                        })(navigator.userAgent || navigator.vendor || window.opera);
                        return check;
                    },

                    getDistanceByLotLang: function (lat1, lon1, lat2, lon2) {
                        let miles = 1.609344;
                        let radlat1 = Math.PI * lat1 / 180;
                        let radlat2 = Math.PI * lat2 / 180;
                        let theta = lon1 - lon2;
                        let radtheta = Math.PI * theta / 180;
                        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                        dist = Math.acos(dist);
                        dist = dist * 180 / Math.PI;
                        dist = dist * 60 * 1.1515;
                        dist = dist * miles
                        return Math.round(dist);
                    }
                },
            };


            // Initiate on window load
            $ = jQuery;
            $(window).on('load', function (e) {
                storeLocator.init();
            });

            $(document).on('click', '.toggle-dealer-content', function () {
                $(this).toggleClass('content-open');
            });

            function autocomplete(inp, arr) {
                /*the autocomplete function takes two arguments,
                the text field element and an array of possible autocompleted values:*/
                let currentFocus;
                /*execute a function when someone writes in the text field:*/

                if (inp != null) {
                    inp.addEventListener("input", function (e) {
                        let a, b, i, val = this.value;
                        /*close any already open lists of autocompleted values*/
                        closeAllLists();
                        if (!val) {
                            return false;
                        }
                        currentFocus = -1;
                        /*create a DIV element that will contain the items (values):*/
                        a = document.createElement("DIV");
                        a.setAttribute("id", this.id + "autocomplete-list");
                        a.setAttribute("class", "autocomplete-items");
                        /*append the DIV element as a child of the autocomplete container:*/
                        this.parentNode.appendChild(a);
                        /*for each item in the array...*/
                        for (i = 0; i < arr.length; i++) {
                            /*check if the item starts with the same letters as the text field value:*/
                            if (arr[i].store && arr[i].store.title && arr[i].store.title.substr(0, val.length).toUpperCase() === val.toUpperCase()) {
                                /*create a DIV element for each matching element:*/
                                b = document.createElement("DIV");
                                /*make the matching letters bold:*/
                                b.innerHTML = "<strong>" + arr[i].store.title.substr(0, val.length) + "</strong>";
                                b.innerHTML += arr[i].store.title.substr(val.length);
                                /*insert a input field that will hold the current array item's value:*/
                                b.innerHTML += "<input type='hidden' value='" + arr[i].store.title + "'>";
                                /*execute a function when someone clicks on the item value (DIV element):*/
                                b.addEventListener("click", function (e) {
                                    /*insert the value for the autocomplete text field:*/
                                    inp.value = this.getElementsByTagName("input")[0].value;
                                    /*close the list of autocompleted values,
                                    (or any other open lists of autocompleted values:*/
                                    closeAllLists();
                                });
                                a.appendChild(b);
                            }
                        }
                    },

                        /*execute a function presses a key on the keyboard:*/
                        inp.addEventListener("keydown", function (e) {
                            let x = document.getElementById(this.id + "autocomplete-list");
                            let input = document.getElementById("locatorCompany");
                            if (x) x = x.getElementsByTagName("div");
                            if (e.keyCode === 40) {
                                /*If the arrow DOWN key is pressed,
                                increase the currentFocus variable:*/
                                currentFocus++;
                                /*and and make the current item more visible:*/
                                addActive(x);
                            } else if (e.keyCode === 38) { //up
                                /*If the arrow UP key is pressed,
                                decrease the currentFocus variable:*/
                                currentFocus--;
                                /*and and make the current item more visible:*/
                                addActive(x);
                            } else if (e.keyCode === 13) {
                                /*If the ENTER key is pressed, prevent the form from being submitted,*/
                                //e.preventDefault();
                                if (currentFocus > -1) {
                                    /*and simulate a click on the "active" item:*/
                                    if (x) x[currentFocus].click();
                                }
                            }
                        }));
                }


                function addActive(x) {
                    /*a function to classify an item as "active":*/
                    if (!x) return false;
                    /*start by removing the "active" class on all items:*/
                    removeActive(x);
                    if (currentFocus >= x.length) currentFocus = 0;
                    if (currentFocus < 0) currentFocus = (x.length - 1);
                    /*add class "autocomplete-active":*/
                    x[currentFocus].classList.add("autocomplete-active");
                }

                function removeActive(x) {
                    /*a function to remove the "active" class from all autocomplete items:*/
                    for (let i = 0; i < x.length; i++) {
                        x[i].classList.remove("autocomplete-active");
                    }
                }

                function closeAllLists(elmnt) {
                    /*close all autocomplete lists in the document,
                    except the one passed as an argument:*/
                    let x = document.getElementsByClassName("autocomplete-items");
                    for (let i = 0; i < x.length; i++) {
                        if (elmnt != x[i] && elmnt != inp) {
                            x[i].parentNode.removeChild(x[i]);
                        }
                    }
                }

            /*execute a function when someone clicks in the document:*/
            document.addEventListener("click", function (e) {
                closeAllLists(e.target);
            });
        }
        }
});
